import React from 'react';
import './AboutBusinessApp.css'

const AboutBusinessApp = () => {
    const services = [
        {
            title: 'Take Payments',
            imgPath: '/img/wallet.svg',
            description: 'Purchase goods, services and products simply within the app, the app helps you control your budget.'
        },
        {
            title: 'Chat With Businesses',
            imgPath: '/img/chat.svg',
            description: 'Chat directly with your customers, receive photos and notifications in real-time.'
        },
        {
            title: 'Display Services & Products',
            imgPath: '/img/cart.svg',
            description: 'Display your services, select the categories and keywords your users will find you by. List your products for sale and take payments directly.'
        },
        {
            title: 'Real Time Reporting',
            imgPath: '/img/analisis.svg',
            description: 'View detailed analytics of how many people have viewed your profile, real time notifications and more. '
        },
    ]
    return (
        // === About Business App section ===
        <div className="about-app-section">
            <div className="container">
                <div className="about-app-content">
                    {/* === Left side images === */}
                    <div className="about-app-left">
                        <div className="img-1">
                            <img src="/img/bg-logo.webp" alt="About app" />
                        </div>
                        <div className="img-2">
                            <img src="/img/about-app.webp" alt="About app" />
                        </div>
                    </div>
                    {/* === About Business app right content === */}
                    <div className="about-app-right">
                        <h1 className="invisible-heading">ABOUT</h1>
                        <h2 className="visible-heading"><span className="heighlight">About</span> <span>Elite Partyz Business App</span></h2>
                        <div className="separetor-ul"></div>
                        <p className="description">The features users can access are next level and essential when it comes to Party & Event planning. Businesses are able to finally have clients directly connected to them instead of spending countless amounts of money trying to capture their target market and convert sales.</p>
                        <div className="about-services">
                            
                            {
                                /* === Service item loop === */
                                services.map((service, index) => {
                                    return(
                                        <div className="services-item" key={`SERVICE${index}`}>
                                            <img className="service-icon" src={service.imgPath} alt="" />
                                            <h4 className="title">{service.title}</h4>
                                            <p className="description">{service.description}</p>
                                        </div>
                                    )
                                })
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutBusinessApp
